module.exports = __webpack_public_path__ + "static/media/carnesyaves_checked.a828d6cc.svg";